import base from './base'
import dark from './dark'
import vtm from './vtm'

export const DEFAULT_THEME = 'base'

export const themes = {
  base,
  dark,
  vtm,
}
